module.exports = __webpack_public_path__ + "c06b75ea0997e8c252b666f9fdf4d80a.png";